export function getSettingsOptions(t) {
  return {
    temperatureUnits: [
      { label: t('settings.unit_selection.celsius'), value: 'celsius' },
      { label: t('settings.unit_selection.fahrenheit'), value: 'fahrenheit' },
    ],
    windSpeedUnits: [
      { label: t('settings.wind_speed_unit_selection.mph'), value: 'mph' },
      { label: t('settings.wind_speed_unit_selection.knots'), value: 'knots' },
      { label: t('settings.wind_speed_unit_selection.kmh'), value: 'km/h' },
      { label: t('settings.wind_speed_unit_selection.ms'), value: 'm/s' },
      { label: t('settings.wind_speed_unit_selection.beaufort'), value: 'beaufort' },
    ],
    precipitationUnits: [
      { label: t('settings.precipitation_unit_selection.mm'), value: 'mm' },
      { label: t('settings.precipitation_unit_selection.inches'), value: 'inches' },
    ],
    theme: [
      { label: t('settings.night_mode_options.system'), value: 'system' },
      { label: t('settings.night_mode_options.light'), value: 'light' },
      { label: t('settings.night_mode_options.dark'), value: 'dark' },
    ],
    provider: [
      { label: t('settings.data_source_options.auto'), value: 'auto', description: t('provider_modal.auto_desc') },
      { label: t('settings.data_source_options.metno'), value: 'metno', description: t('provider_modal.metno_desc') },
      { label: t('settings.data_source_options.meteofrance'), value: 'meteofrance', description: t('provider_modal.meteofrance_desc') },
      { label: t('settings.data_source_options.appleweather'), value: 'appleweather', description: t('provider_modal.appleweather_desc') },
      { label: t('settings.data_source_options.googleweather'), value: 'googleweather', description: t('provider_modal.googleweather_desc') },
    ],
    locale: [
      { label: t('settings.language_selection.en'), value: 'en' },
      { label: t('settings.language_selection.de'), value: 'de' },
      { label: t('settings.language_selection.es'), value: 'es' },
      { label: t('settings.language_selection.fr'), value: 'fr' },
      { label: t('settings.language_selection.it'), value: 'it' },
    ],
  };
}